import React, { useState } from 'react'
import { gql, useQuery, useMutation } from 'urql'
import FormDialog from '../dialogs/FormDialog'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { DateTime } from 'luxon'

const availableBlocksQuery = gql`
  query scheduleSelectionAvailableBlocks($id: ID!) {
    scheduleSelection(id: $id) {
      id
      timeZone
      availableBlocks {
        id
        blockIndex
        startTime
        endTime
      }
    }
  }
`

const pickMutation = gql`
  mutation pickBlock($input: PickScheduleSelectionBlockInput!) {
    pickScheduleSelectionBlock(input: $input)
  }
`

interface ScheduleSelectionPickDialogProps {
  selectionID: string
  onClose: () => void
}

export default function ScheduleSelectionPickDialog(
  props: ScheduleSelectionPickDialogProps,
): React.JSX.Element {
  const { selectionID, onClose } = props
  const [selectedBlockID, setSelectedBlockID] = useState<string>('')

  const [q] = useQuery({
    query: availableBlocksQuery,
    variables: { id: selectionID },
  })
  const [pickResult, pick] = useMutation(pickMutation)

  const sel = q.data?.scheduleSelection
  const blocks = sel?.availableBlocks || []
  const timeZone = sel?.timeZone || 'UTC'

  return (
    <FormDialog
      title='Pick Your On-Call Block'
      maxWidth='sm'
      loading={pickResult.fetching}
      errors={
        pickResult.error
          ? [{ message: pickResult.error.message }]
          : undefined
      }
      onClose={onClose}
      onSubmit={() =>
        pick({
          input: { selectionID, blockID: selectedBlockID },
        }).then((res) => {
          if (!res.error) {
            onClose()
          }
        })
      }
      disableSubmit={!selectedBlockID}
      primaryActionLabel='Confirm Pick'
      form={
        <List>
          {blocks.map((block: any) => {
            const start = DateTime.fromISO(block.startTime, { zone: timeZone })
            const end = DateTime.fromISO(block.endTime, { zone: timeZone })
            return (
              <ListItemButton
                key={block.id}
                selected={selectedBlockID === block.id}
                onClick={() => setSelectedBlockID(block.id)}
              >
                <ListItemText
                  primary={`Block ${block.blockIndex + 1}`}
                  secondary={`${start.toFormat('EEE, MMM d, yyyy h:mm a')} - ${end.toFormat('EEE, MMM d, yyyy h:mm a')}`}
                />
              </ListItemButton>
            )
          })}
          {blocks.length === 0 && (
            <ListItemText primary='No available blocks' />
          )}
        </List>
      }
    />
  )
}
